angular.module('bmsApp.settings')
	.controller('GeneralTermsAndConditionsCtrl', GeneralTermsAndConditionsCtrl);

GeneralTermsAndConditionsCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'$timeout',
	'Upload',
	'notify',
	'LicenseOptionsSvc',
	'LicenseDetailSvc',
];

function GeneralTermsAndConditionsCtrl($scope, $state, $q, $timeout, Upload, notify, LicenseOptionsSvc, LicenseDetailSvc) {
	let self = this;
	let handlers = {};

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		options: {},
		showForm: false,
		licenseDetail: {}
	});

	this.$onInit = () => {
		let promises = {
			licenses: LicenseOptionsSvc.license()
				.then((response) => {
					self.options.licenses = response.data.options;
				}),
		};
		$q.all(promises)
			.then((response) => {
				self.loading = false;
			});

	};


	// Handlers --------------------------------------------------------------------------------------------------------
	

	

	handlers.licenseChanged = () => {
		self.loading = true;
		self.licenseDetail = {};
		LicenseDetailSvc.read(self.license.id)
			.then((response) => {
				self.showForm = true;
				self.licenseDetail.id = self.license.id;
				self.licenseDetail.file = response.data.license?response.data.license.file:{};
				// self.ecom_route_configuration = response.data.ecom_route_configuration;
				self.loading = false;
			});
	};


	handlers.uploadFiles = (files) => {
		self.uploadInProgress = true;
		let promises = [];
		let file = files[0];
		promises.push(Upload.upload({
			url: 'api/file/upload',
			data: {
				file: file,
				nitro: true
			}
		}));

		$q.all(promises)
			.then(function (responses) {
				angular.forEach(responses, function (response) {
					self.licenseDetail.file = response.data.file;
				});
				$timeout(function () {
					self.isDragging = false;
					self.uploadInProgress = false;
				});
			}, function (errors) {
				$timeout(function () {
					self.isDragging = false;
					self.uploadInProgress = false;
				});

			});

	};


	handlers.submitClick = function () {
		LicenseDetailSvc.addLicenseTermFile(self.licenseDetail)
			.then((response) => {
				notify({
					message: 'General T&C successfully saved'
				});
			},function (error) {
					processing = false;
					$scope.errors = error;
				});
	};
}
